export default __webpack_public_path__ + "static/media/BarlowSemiCondensed-SemiBold.965eb934.ttf";